module.exports = __webpack_public_path__ + "static/06-50676d0485a38a3a226cbf991a6dcfb3.jpg";